<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize mr-2">
          {{ $t("action_plan.list.filters.tenants") }}
        </label>
        <v-select
          :options="tenantOptions"
          :clearable="false"
          :reduce="(val) => val.value"
          input-id="id_tenant"
          multiple
          class="w-100"
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row
      align-v="center"
      class="d-flex align-items-center"
      v-if="$can('filter_datetime', 'Alarm')"
    >
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("action_plan.list.filters.start_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="startDatetime"
            @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("action_plan.list.filters.end_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="endDatetime"
            @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    vSelect,
    BBadge,
    flatPickr,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
